import { useQuery } from "react-query";
import ApiService from "../services/ApiService";
import { SelectOption } from "@cinesys/ui/components";
const apiPath = "/api/select_option/_/organization";

export const useOrganizationQuery = (enabled?: boolean) => {
  return useQuery({
    queryKey: ["select_options", apiPath],
    queryFn: async () => {
      const response = await ApiService.fetch<{ data: SelectOption[] }>(
        "GET",
        apiPath
      );
      return response.data;
    },
    enabled: enabled !== false,
  });
};
